<md-toolbar color="accent"
            id="navbar"
            [ngClass]="{'billy': afService.isBilly}"
            class="hidden-print">
  <a class="logo"
     (click)="goHome()">
    <img class="logo-img"
         src="https://firebasestorage.googleapis.com/v0/b/storpug-dev.appspot.com/o/pug%20body.png?alt=media&token=75d252d3-c2f1-43f2-807c-b29c135b824c">
  </a>
  <p class="version-numbah">&nbsp;&nbsp;&nbsp;v{{version}}</p>
  <p-dropdown #dd
              class="hidden-xs"
              (onChange)="goToClient()"
              [options]="facilities"
              [resetFilterOnHide]="true"
              [autoDisplayFirst]="false"
              [autoWidth]="false"
              [(ngModel)]="switchToClientKey"
              filter="true"></p-dropdown>
  <marquee *ngIf="devEnv"
           behavior="alternate"
           scrollamount="10">
    <h1 class="dev-env">*THIS IS THE DEV ENVIRONMENT*</h1>
  </marquee>

  <!-- This fills the remaining space of the current row -->
  <span class="fill-remaining-space"></span>
  <!-- <app-select-location-dropdown *ngIf="afService.isLocation"
                                [clientKey]="currentClientKey"
                                (selectedLocation)="changeSelectedLocation($event)"
                                [selectedLocationData]="locationData"></app-select-location-dropdown> -->
  <span class="hidden-xs"
        style="margin-left: 15px;">
    <div class="btn-group"
         dropdown
         placement="top left">
      <button dropdownToggle
              type="button"
              class="btn btn-default btn-lg btnCheckbox dropdown-toggle"
              style="box-shadow: 0 0px 0px 0 rgba(0, 0, 0, 0);margin-right: 20px;">
        Menu
      </button>
      <ul *dropdownMenu
          class="dropdown-menu dropdown-menu-right"
          role="menu">
        <li role="menuitem">
          <a class="dropdown-item"
             [routerLink]="['files']">File Uploads</a>
        </li>
        <li role="menuitem">
          <a class="dropdown-item"
             (click)="goToEmailTracker()">email</a>
        </li>
        <li role="menuitem">
          <a class="dropdown-item"
             (click)="goToPugglStats()">pug.gl</a>
        </li>
        <li class="divider dropdown-divider"></li>
        <li role="menuitem">
          <a class="dropdown-item"
             (click)="afService.logout()">Logout</a>
        </li>
      </ul>
    </div>

  </span>

  <div id="nav-icon3"
       class="visible-xs"
       (click)="toggleMobileMenu()"
       [class.open]="showMobileMenu">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>

  <md-toolbar-row *ngIf="showMobileMenu == true"
                  class="visible-xs">
    <a class="hvr-shutter-out-horizontal mobile-nav-button"
       [routerLink]="['files']"
       (click)="toggleMobileMenu()">File Uploads</a>
    <a class="hvr-shutter-out-horizontal mobile-nav-button"
       (click)="goToEmailTracker()"
       (click)="toggleMobileMenu()"><span>email</span></a>
    <a class="hvr-shutter-out-horizontal mobile-nav-button"
       (click)="goToPugglStats()"
       (click)="toggleMobileMenu()"><span>pug.gl</span></a>
    <a class="hvr-shutter-out-horizontal mobile-nav-button"
       (click)="afService.logout()"
       (click)="toggleMobileMenu()"><span>Logout</span></a>
  </md-toolbar-row>

  <!--<md-toolbar-row *ngIf="showMobileMenu == true" class="visible-xs">-->
  <!--<a class="hvr-shutter-out-horizontal mobile-nav-button" [routerLink]="[ '/portal-login' ]"><span>Portal</span></a>-->
  <!--</md-toolbar-row>-->
</md-toolbar>



// WEBPACK FOOTER //
// ./src/ng2/app/components/navbar/navbar.component.html